<template>
  <Drawer
    :drawer="drawer"
    customTitle
    :appendToBody="false"
    :size="1400"
    @close="handleClose"
  >
    <span slot="title">
      核销记录
      <label class="title" style="margin-left: 10px">
        {{ rowData.companyName || rowData.supplierName }}</label
      >
    </span>
    <div class="log-body">
      <div class="header">
        <el-row>
          <el-col v-if="!active" :span="3">
            <label class="label">业务员</label>
            <span class="value"> {{ rowData.saleName }}</span>
          </el-col>
          <el-col :span="4">
            <label class="label">账单总金额</label>
            <span class="value"> {{ rowData.invoiceAmount }}</span>
          </el-col>
          <el-col :span="4">
            <label class="label">已核销金额</label>
            <span class="value"> {{ rowData.verifedAmount }}</span>
          </el-col>
          <el-col :span="4">
            <label class="label">账单未核销金额</label>
            <span class="value"> {{ rowData.unverifyInoviceAmount }}</span>
          </el-col>
          <el-col :span="4">
            <label class="label">剩余可核销金额</label>
            <span class="value"> {{ rowData.remainingVerifiableAmount }}</span>
          </el-col>
          <el-col :span="5">
            <label class="label">最后核销日期</label>
            <span class="value">
              {{ rowData.lastVerifyDate }}
            </span>
          </el-col>
        </el-row>
      </div>
      <div class="filter">
        <!-- <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
              :default="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="filterList.numbers"
            placeholder="请输入账单号/柜号查询"
            class="input-search"
            size="mini"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div> -->
        <label class="label">核销日期</label>
        <el-date-picker
          v-model="filterList.verifyDate"
          style="width: 220px"
          type="daterange"
          size="mini"
          range-separator="至"
          align="center"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          @change="handleChange"
        >
        </el-date-picker>
        <!-- <label class="label">账单日期</label>
        <el-date-picker
          v-model="filterList.invoiceDate"
          style="width: 220px"
          size="mini"
          type="daterange"
          range-separator="至"
          align="center"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          @change="handleChange"
        >
        </el-date-picker> -->
      </div>
      <BaseTable
        style="margin-top: 10px"
        :height="height"
        :tableData="tableData"
        :loading="loading"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :pageSizes="[20, 50, 100, 500]"
        :isPager="true"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <template slot="opt" slot-scope="row">
          <el-button
            size="mini"
            type="text"
            @click="verificationLog(row.scope)"
          >明细</el-button
          >
        </template>
        <template #custom-total>
          <div class="custom-total">
            <div style="display: flex">
              <div class="select">已选 {{ selectionItem.length }} 项</div>
              <div
                v-permissson="'deleteRow'"
                class="btn-bol"
                @click="handleCancelVerify"
              >
                取消核销
              </div>
              <div class="btn-bol" @click="exportFile">导出</div>
            </div>
          </div>
        </template>
      </BaseTable>
      <p class="detail">核销明细</p>
      <div class="filter" style="justify-content: space-between">
        <div>
          <div class="btn-bol" @click="exportDetailFile">导出</div>
        </div>
        <div style="display: flex">
          <div class="search">
            <el-popover
              ref="popover"
              placement="top"
              class="searchPop"
              title="批量搜索"
              trigger="click"
              width="378"
            >
              <div class="close" @click="closeSearchPanel">
                <i class="el-icon-close"></i>
              </div>
              <base-muti-input
                ref="baseMutiInput"
                v-model="referenceNumber"
                :default="referenceNumber"
              ></base-muti-input>
              <div style="text-align: right; margin: 16px 0 0">
                <el-button size="small" @click="handleEmpty">清空</el-button>
                <div class="sure" @mousedown="handleConfirm">确定</div>
              </div>
            </el-popover>
            <el-input
              :value="filterList.numbers"
              placeholder="请输入账单号/柜号查询"
              class="input-search"
              size="mini"
              @focus="handleFocus"
            ></el-input>
            <div class="btn-search" @click="handleConfirm">
              <i class="el-icon-search"></i>
            </div>
          </div>
          <label class="label">核销日期</label>
          <el-date-picker
            v-model="filterList.verifyDetailDate"
            style="width: 220px"
            type="daterange"
            size="mini"
            range-separator="至"
            align="center"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            unlink-panels
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="handleDetailChange"
          >
          </el-date-picker>
        </div>
        <!-- <label class="label">账单日期</label>
        <el-date-picker
          v-model="filterList.invoiceDate"
          style="width: 220px"
          size="mini"
          type="daterange"
          range-separator="至"
          align="center"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          @change="handleDetailChange"
        >
        </el-date-picker> -->
      </div>
      <BaseTable
        :height="height"
        :tableData="tableData1"
        :loading="detailLoading"
        :pageIndex="pager1.pageIndex"
        :pageSize="pager1.pageSize"
        :pageSizes="[20, 50, 100, 500]"
        :isPager="true"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange1"
      >
      </BaseTable>
    </div>
    <VerificationDetailDialog
      :dialogVisible="dialogVisible"
      :rowData="tableRow"
      @cancel="dialogVisible = false"
    ></VerificationDetailDialog>
  </Drawer>
</template>
<script>
import {
  verifyDetailPages,
  cancelVerify,
  verifyPages,
  verifyDetailPagesBySupplier,
  cancelVerifyBySupplier,
  verifyPagesBySupplier
} from '@/api/fee'
const BaseMutiInput = () => import('@/components/base/BaseMutiInput.vue')

const BaseTable = () => import('@/components/table/BaseTable.vue')
const Drawer = () => import('@/components/drawer/Drawer')
import VerificationDetailDialog from './VerificationDetailDialog'
import { derive } from '@/utils/common'
import dayjs from 'dayjs'
export default {
  components: { BaseTable, Drawer, BaseMutiInput, VerificationDetailDialog },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      detailLoading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: {
        fileds: [
          {
            filed: 'verifyDate',
            label: '核销时间',
            width: ''
          },
          {
            filed: 'verifedAmount',
            label: '核销金额',
            width: ''
          },
          {
            filed: 'handAmount',
            label: '手续费',
            width: ''
          },
          {
            filed: 'realAmount',
            label: '入账金额',
            width: ''
          },
          {
            filed: 'bankAccountNumber',
            label: '收款账号',
            width: ''
          },
          {
            filed: 'receiptOn',
            label: '收款日期',
            width: '',
            formatter: row => {
              return dayjs(row.receiptOn).format('YYYY-MM-DD')
            }
          },
          {
            filed: 'bankName',
            label: '收款银行',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '60',
            isCustom: true
          }
        ],
        columns: [],
        mutiCheck: true,
        total: 0
      },
      tableData1: {
        fileds: [
          {
            filed: 'containerNo',
            label: '柜号',
            width: ''
          },
          {
            filed: 'invoiceNumber',
            label: '账单号码',
            width: ''
          },
          {
            filed: 'invoiceDateStr',
            label: '账单日期',
            width: ''
          },
          {
            filed: 'verifedAmount',
            label: '核销金额',
            width: ''
          },
          {
            filed: 'verifyDate',
            label: '核销日期',
            width: ''
          }
        ],
        columns: [],
        // mutiCheck: true,
        total: 0
      },
      height: 0,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      pager1: {
        pageIndex: 1,
        pageSize: 20
      },
      referenceNumber: '',
      filterList: {
          numbers: '',
          verifyDate: '',
          verifyDetailDate: '',
          invoiceDate: ''
      },
      dialogVisible: false,
      tableRow: {},
      selectionItem: []
    }
  },
  watch: {
    async drawer(val) {
      if (val) {
        // await this.getLists(this.pager)
        this.tableData1.columns = []
        this.filterList = {
          numbers: '',
          verifyDate: '',
          verifyDetailDate: '',
          invoiceDate: ''
        }
        this.tableRow = {}
        this.selectionItem = []
        this.initList()
        this.$nextTick(() => {
          this.height =
            (document.querySelector('.log-body').offsetHeight - 200 - 40 - 40) /
            2
        })
      }
    }
  },
  methods: {
    handleChange() {
      this.pager = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getLists(this.pager)
    },
    handleDetailChange() {
      this.pager1 = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getDetailLists(this.pager1)
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.filterList.numbers = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager1 = param
      this.getDetailLists(param)
    },

    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = param
      this.getLists(param)
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.filterList.numbers = this.referenceNumber
        }
        this.$refs.popover.doClose()
        const param = {
          pageIndex: 1,
          pageSize: 20
        }
        this.pager1 = param
        this.getDetailLists(param)
      }, 0)
    },
    async getLists(params) {
      try {
        params = {
          ...params,
          queryParam: {
            ...this.formatterFilter()
          }
        }
        this.loading = true
        let res
        if (!this.active) {
          res = await verifyPages(params)
        } else {
          res = await verifyPagesBySupplier(params)
        }
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getDetailLists(params) {
      try {
        params = {
          ...params,
          queryParam: {
            ...this.formatterFilter(1)
          }
        }
        this.detailLoading = true
        let res
        if (!this.active) {
          res = await verifyDetailPages(params)
        } else {
          res = await verifyDetailPagesBySupplier(params)
        }
        this.detailLoading = false
        if (res.success) {
          this.tableData1.columns = res.data.list
          this.tableData1.total = res.data.total
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    formatterFilter(type = 0) {
      // 0 列表 1 详情
      return {
        verifyId: this.tableRow.verifyId,
        companyId: this.rowData.companyId,
        supplierId: this.rowData.supplierId,
        numbers:
          this.filterList.numbers.length > 0
            ? this.filterList.numbers
            : undefined,
        verifyDateStart:
          type === 0
            ? this.filterList.verifyDate !== '' && this.filterList.verifyDate
              ? this.filterList.verifyDate[0]
              : undefined
            : this.filterList.verifyDetailDate !== '' &&
              this.filterList.verifyDetailDate
            ? this.filterList.verifyDetailDate[0]
            : undefined,
        verifyDateEnd:
          type === 0
            ? this.filterList.verifyDate !== '' && this.filterList.verifyDate
              ? this.filterList.verifyDate[1]
              : undefined
            : this.filterList.verifyDetailDate !== '' &&
              this.filterList.verifyDetailDate
            ? this.filterList.verifyDetailDate[1]
            : undefined,
        invoiceDateStart:
          this.filterList.invoiceDate !== '' && this.filterList.invoiceDate
            ? this.filterList.invoiceDate[0]
            : undefined,
        invoiceDateEnd:
          this.filterList.invoiceDate !== '' && this.filterList.invoiceDate
            ? this.filterList.invoiceDate[1]
            : undefined
      }
    },
    handlePageChange(pager) {
      this.pager = {
        ...this.pager,
        ...pager
      }
      const params = {
        ...this.pager,
        ...pager
      }
      this.getLists(params)
    },
    handlePageChange1(pager) {
      this.pager1 = {
        ...this.pager1,
        ...pager
      }
      const params = {
        ...this.pager1,
        ...pager
      }
      this.getLists(params)
    },
    handleClose() {
      this.$emit('close')
    },
    verificationLog(row) {
      this.tableRow = row
      this.getDetailLists(this.pager1)
      // this.dialogVisible = true
    },
    handleCancelVerify() {
      if (this.selectionItem.length === 0) {
        this.$message.error('未勾选数据')
        return false
      }
      this.$confirm('确认取消核销？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.cancelVerify()
        })
        .catch(() => {})
    },
    async exportFile() {
      if (this.tableData.columns.length === 0) return
      this.loading = true
      if (!this.active) {
        await derive('CustomerInvoice/exportVerify', 'post', this.formatterFilter())
      } else {
        await derive(
          'SupplierInvoice/exportVerify',
          'post',
          this.formatterFilter(),
        )
      }
      this.loading = false
    },
    async exportDetailFile() {
      if (this.tableData1.columns.length === 0) return
      this.loading = true
      if (!this.active) {
        await derive(
          'CustomerInvoice/exportVerifyDetail',
          'post',
          this.formatterFilter(),
        )
      } else {
        await derive(
          'SupplierInvoice/exportVerifyDetail',
          'post',
          this.formatterFilter(),
        )
      }
      this.loading = false
    },
    async cancelVerify() {
      try {
        const verifyIds = this.selectionItem.map((a) => a.verifyId).join(',')
        this.loading = true
        let res
        if (!this.active) {
          res = await cancelVerify({ verifyIds })
        } else {
          res = await cancelVerifyBySupplier({ verifyIds })
        }
        this.loading = false
        if (res.success) {
          this.$message.success('取消核销成功')
          this.getLists(this.pager)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleSelectionChange(item) {
      this.selectionItem = item
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  display: inline-block;
  width: auto;
  height: 16px;
  background: rgba(105, 89, 205, 0.1);
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #6959cd;
  line-height: 16px;
}
.log-body {
  width: calc(100% - 40px);
  height: 100%;
  margin: 20px auto 20px;
  .custom-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    position: absolute;
    height: 40px;
    background: #f7f7f7;
    border: 1px solid #eeeeee;
    border-top: 0;
    padding-left: 17px;
    padding-right: 40px;
    box-sizing: border-box;
    z-index: 2;
    .select {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
    }
    .total {
      margin-left: 16px;
      font-size: 14px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      color: #333333;
      line-height: 40px;
      span {
        color: #fe453d;
        font-weight: bold;
        line-height: 40px;
      }
    }
    .batchCounterAudit {
      width: 120px;
      height: 30px;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #33c481;
      cursor: pointer;
      box-sizing: border-box;
      margin-left: 5px;
      margin-top: 5px;
      border-radius: 2px 2px 2px 2px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #33c481;
    }
  }
  .header {
    width: 100%;
    background: #fbfbfb;
    border-radius: 6px 6px 6px 6px;
    padding: 16px 32px;
    box-sizing: border-box;
    .label {
      display: inline-block;
      width: 94px;
      height: 16px;
      background: rgba(105, 89, 205, 0.1);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #6959cd;
      line-height: 16px;
    }
    .value {
      height: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 16px;
      margin-left: 6px;
    }
  }
  .filter {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    .label {
      height: 30px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 14px;
      color: #909399;
      line-height: 30px;
      margin-left: 10px;
    }
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 5px;
      color: #2c3e50;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
  }
  .detail {
    width: 100%;
    height: 40px;
    color: rgb(255, 255, 255);
    background-color: #304156;
    border-color: #304156;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}

.btn-bol {
  width: 80px;
  height: 30px;
  background: #ffffff;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid rgb(18, 88, 188);
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: rgb(18, 88, 188);
  line-height: 30px;
  text-align: center;
  margin-left: 5px;
  margin-top: 5px;
  cursor: pointer;
}
</style>
